import { combineReducers } from '@reduxjs/toolkit';
import appReducer from './features/app/appSlice';
import commonDataReducer from './features/commonData/commonDataSlice';
import notificationBannerReducer from './features/notificationBanner/notificationBannerSlice';
import chatSessionsReducer from './features/chatSessions/chatSessionsSlice';
import agentsReducer from './features/agents/agentsSlice';
import chatMessagesReducer from './features/chatMessages/chatMessagesSlice';
import chatUiReducer from './features/chatUi/chatUiSlice';
import layoutReducer from './features/layout/layoutSlice';
import usersReducer from './features/users/usersSlice';
import chatPersonalizationReducer from './features/chatPersonalization/chatPersonalizationSlice';
import documentsReducer from './features/chatDocuments/chatDocumentsSlice';
import migrationContextReducer from './features/migrationContext/migrationContextSlice';

export const rootReducer = combineReducers({
    app: appReducer,
    commonData: commonDataReducer,
    notificationBanner: notificationBannerReducer,
    chatSessions: chatSessionsReducer,
    agents: agentsReducer,
    chatMessages: chatMessagesReducer,
    chatUi: chatUiReducer,
    layout: layoutReducer,
    users: usersReducer,
    chatPersonalization: chatPersonalizationReducer,
    migrationContext: migrationContextReducer,
    documents: documentsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
